import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class lists with conflict resolution.
 *
 * `clsx` flattens conditional class inputs; `twMerge` then dedupes conflicting
 * Tailwind utilities (e.g. `px-2 px-4` → `px-4`) so the last one wins. This is the
 * standard shadcn `cn` helper, vendored locally so the Trust Center SPA has no
 * dependency on the portal's `@/lib/utils`.
 * Source: https://ui.shadcn.com/docs/installation/vite (utils setup)
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
